import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppState, Auth0Provider } from '@auth0/auth0-react';
import { auth0_params, auth0ClientId, auth0Domain } from './config';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './app/store';
import 'mapbox-gl/dist/mapbox-gl.css';
import { createRenderer } from 'fela';
import { RendererProvider, ThemeProvider } from 'react-fela';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import theme from './utils/theme';

const renderer = createRenderer();

// Navigate through react-router after login so returnTo (e.g. the page the session expired on) is honoured
const Auth0ProviderWithNavigate = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState?: AppState) => {
    navigate(appState?.returnTo ?? '/', { replace: true });
  };

  return (
    <Auth0Provider
      domain={auth0Domain()}
      clientId={auth0ClientId()}
      authorizationParams={{
        redirect_uri: auth0_params.redirectUri,
        scope: "openid profile email offline_access",
        audience: 'api.modulconnect.com.customer',
      }}
      useRefreshTokens={true}
      cacheLocation='localstorage'
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <RendererProvider renderer={renderer}>
      <ThemeProvider theme={theme}>
        <MuiThemeProvider theme={theme.mui}>
          <BrowserRouter>
            <Provider store={store}>
              <Auth0ProviderWithNavigate>
                <App />
              </Auth0ProviderWithNavigate>
            </Provider>
          </BrowserRouter>
        </MuiThemeProvider>
      </ThemeProvider>
    </RendererProvider>
  </React.StrictMode >
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
